import { AuditLogEntry, UserSession } from '../types';
import { syncAuditLogsToSupabase } from './supabaseSync';

const AUDIT_LOGS_KEY = 'halisaha_audit_logs';

function safeRead<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

function safeWrite<T>(key: string, value: T) {
  localStorage.setItem(key, JSON.stringify(value));
}

function sessionToActor(session: UserSession | null): { actorRole: AuditLogEntry['actorRole']; actorId?: string } {
  if (!session) return { actorRole: 'system' };
  if (session.role === 'admin') return { actorRole: 'admin' };
  if (session.role === 'owner') return { actorRole: 'owner', actorId: session.ownerId };
  return { actorRole: 'customer', actorId: session.userId };
}

export function getAuditLogs(limit?: number): AuditLogEntry[] {
  const logs = safeRead<AuditLogEntry[]>(AUDIT_LOGS_KEY, []);
  const sorted = logs.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  return typeof limit === 'number' ? sorted.slice(0, limit) : sorted;
}

export function logAuditEvent(input: {
  session?: UserSession | null;
  action: string;
  targetType: AuditLogEntry['targetType'];
  targetId?: string;
  meta?: Record<string, unknown>;
}): AuditLogEntry {
  const actor = sessionToActor(input.session ?? null);
  const current = safeRead<AuditLogEntry[]>(AUDIT_LOGS_KEY, []);
  const next: AuditLogEntry = {
    id: `audit-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    actorRole: actor.actorRole,
    actorId: actor.actorId,
    action: input.action,
    targetType: input.targetType,
    targetId: input.targetId,
    meta: input.meta,
    createdAt: new Date().toISOString(),
  };
  safeWrite(AUDIT_LOGS_KEY, [next, ...current]);
  syncAuditLogsToSupabase();
  return next;
}
